/* Native replacements for the Webflow interaction runtime (webflow.js, IX2, Lottie player).
   Vanilla JS, no jQuery. Each section notes the Webflow interaction it replaces.
   Paired with assets/css/site.css. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------- mega menu (IX2 a-12 / a-13)
     MOUSE_CLICK / MOUSE_SECOND_CLICK on .nav_list_item.is-menu */
  var menu = document.querySelector('.nav_mega_menu_wrap');
  var menuTriggers = Array.prototype.slice.call(document.querySelectorAll('.nav_list_item.is-menu button, #menu-toggle, .nav_btn_wrap.is-menu'));

  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('nav-open', open);
    menuTriggers.forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
  }
  if (menu && menuTriggers.length) {
    menuTriggers.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', menu.id || (menu.id = 'nav-mega-menu'));
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setMenu(!menu.classList.contains('is-open'));
      });
    });
    // close on a link, on the backdrop, and on Escape
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a[href]:not([href="#"])')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) setMenu(false);
    });
  }

  /* ------------------------------------------- size guide popup (IX2 a-7 / a-8)
     MOUSE_CLICK / MOUSE_SECOND_CLICK on .product_nutritional_txt_wrap */
  var guide = document.querySelector('.nutritional_wrap');
  if (guide) {
    var openGuide = function (open) {
      guide.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest('.product_nutritional_txt_wrap')) { e.preventDefault(); openGuide(true); return; }
      if (e.target.closest('.nutritional_close_wrap') || e.target.closest('.nutritional_overlay')) { e.preventDefault(); openGuide(false); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && guide.classList.contains('is-open')) openGuide(false);
    });
  }

  /* ------------------------------------------------ scroll parallax (IX2 a-9 / a-11)
     SCROLLING_IN_VIEW: floating shirts move to yPercent -40 across their scroll range;
     the sandwich groups move and rotate. Uses GSAP ScrollTrigger, already loaded for
     the marquees; skipped entirely when the user prefers reduced motion. */
  function initParallax() {
    if (reduced || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);
    document.querySelectorAll('.g_berry_wrap').forEach(function (el) {
      gsap.fromTo(el, { yPercent: 0 }, {
        yPercent: -40, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: 1 }
      });
    });
    document.querySelectorAll('.g_sandwich_rotation_div').forEach(function (el) {
      gsap.fromTo(el, { yPercent: 0, rotate: 0 }, {
        yPercent: -25, rotate: 12, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: 1 }
      });
    });
  }

  /* --------------------------------------- card 3D perspective (IX2 a-6, MOUSE_MOVE)
     Desktop-only ("main" breakpoint in Webflow). Cursor position inside
     .g_card_hover_trigger drives, with heavy smoothing:
       the card      rotateY -10deg (left) .. +10deg (right)
                     rotateX +10deg (top)  .. -10deg (bottom)
       .g_card_orb   x +50% .. -50%   and   y -50% .. +50%
       .g_streak     x +20% .. -20%
     Resting state is the centre, so it eases back when the cursor leaves. */
  function initCardTilt() {
    if (reduced) return;
    document.querySelectorAll('.g_card_hover_trigger').forEach(function (card) {
      card.setAttribute('data-tilt', '1');   // marker: this card is wired
      var orbs = card.querySelectorAll('.g_card_orb');
      var streaks = card.querySelectorAll('.g_streak');
      var tx = 0.5, ty = 0.5, cx = 0.5, cy = 0.5, raf = null;

      function frame() {
        cx += (tx - cx) * 0.07;             // smoothing: Webflow had 95
        cy += (ty - cy) * 0.07;
        var px = cx - 0.5, py = cy - 0.5;   // -0.5 .. +0.5
        card.style.transform = 'perspective(1200px) rotateX(' + (-py * 20).toFixed(2) + 'deg) rotateY(' + (px * 20).toFixed(2) + 'deg)';
        var ox = (-px * 100).toFixed(1), oy = (py * 100).toFixed(1);
        orbs.forEach(function (o) { o.style.transform = 'translate(' + ox + '%,' + oy + '%)'; });
        streaks.forEach(function (s) { s.style.transform = 'translateX(' + (-px * 40).toFixed(1) + '%)'; });
        raf = (Math.abs(tx - cx) > 0.0008 || Math.abs(ty - cy) > 0.0008) ? requestAnimationFrame(frame) : null;
      }
      function start() { if (!raf) raf = requestAnimationFrame(frame); }

      card.addEventListener('mousemove', function (e) {
        if (window.innerWidth < 992) return;
        var r = card.getBoundingClientRect();
        tx = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
        ty = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
        start();
      });
      card.addEventListener('mouseleave', function () { tx = 0.5; ty = 0.5; start(); });
    });
  }

  /* ------------------------------------------- footer blur follow (IX2 a-5, MOUSE_MOVE)
     The soft blob tracks the cursor inside the footer. */
  function initFooterBlur() {
    if (reduced) return;
    document.querySelectorAll('.footer_wrap').forEach(function (footer) {
      var blob = footer.querySelector('.footer_blur_follow');
      if (!blob) return;
      footer.setAttribute('data-blur-follow', '1');   // marker: cursor-follow is wired
      var raf = null, tx = 0, ty = 0;
      footer.addEventListener('mousemove', function (e) {
        var r = footer.getBoundingClientRect();
        tx = e.clientX - r.left - blob.offsetWidth / 2;
        ty = e.clientY - r.top - blob.offsetHeight / 2;
        if (!raf) raf = requestAnimationFrame(function () {
          raf = null;
          blob.style.transform = 'translate(' + Math.round(tx) + 'px,' + Math.round(ty) + 'px)';
        });
      });
    });
  }

  /* ---------------------------------------------------------- fan wall video
     The four clips weigh 20MB together and sit far below the fold. The export
     set autoplay on every video and called play() on loadedmetadata, so a phone
     buffered all of them on load: 6.4MB measured before any was on screen. Each
     video now carries data-src with preload="none", so the source is attached
     only as the clip approaches the viewport, and playback stops once it leaves. */
  function initLazyVideo() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('video[data-src]'));
    if (!videos.length) return;

    function attach(video) {
      if (!video.dataset.src) return;
      video.src = video.dataset.src;
      delete video.dataset.src;
      video.load();
    }
    function play(video) {
      if (reduced) return;                 // honour prefers-reduced-motion
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* browser declined, leave it paused */ });
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(attach);              // old browser: fall back to loading them
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          attach(video);
          play(video);
        } else if (!video.paused) {
          video.pause();                   // stop decoding once it scrolls away
        }
      });
    }, { rootMargin: '200px 0px' });
    videos.forEach(function (video) { io.observe(video); });
  }

  /* --------------------------------------------------------------- Webflow forms
     webflow.js used to intercept form submits and reveal .w-form-done. These forms
     have no backend in the prototype, so keep the same feedback without navigating. */
  function initForms() {
    document.querySelectorAll('.w-form form').forEach(function (form) {
      // A real Shopify form (contact, newsletter, customer) carries form_type and
      // must be allowed to submit. Only the backend-less prototype forms are faked.
      if (form.querySelector('input[name="form_type"]')) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var wrap = form.closest('.w-form');
        var done = wrap && wrap.querySelector('.w-form-done');
        if (done) { form.style.display = 'none'; done.style.display = 'block'; }
      });
    });
  }


  /* ------------------------------------------------------------- form controls
     webflow.js mirrored the native input state onto the custom radio/checkbox
     visuals as .w--redirected-checked / .w--redirected-focus. Doing the same
     here keeps every existing style rule for those states working. */
  function syncFormControls(scope) {
    (scope || document).querySelectorAll('.w-radio, .w-checkbox').forEach(function (label) {
      var input = label.querySelector('input[type="radio"], input[type="checkbox"]');
      var visual = label.querySelector('.w-form-formradioinput, .w-checkbox-input');
      if (!input || !visual) return;
      visual.classList.toggle('w--redirected-checked', input.checked);
    });
  }
  function initFormControls() {
    document.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('input[type="radio"], input[type="checkbox"]')) return;
      // radios share a name, so re-sync the whole form, not just this label
      syncFormControls(e.target.form || document);
    });
    document.addEventListener('focusin', function (e) {
      if (!e.target.matches || !e.target.matches('input[type="radio"], input[type="checkbox"]')) return;
      var v = e.target.closest('.w-radio, .w-checkbox');
      v = v && v.querySelector('.w-form-formradioinput, .w-checkbox-input');
      if (v) v.classList.add('w--redirected-focus');
    });
    document.addEventListener('focusout', function (e) {
      if (!e.target.matches || !e.target.matches('input[type="radio"], input[type="checkbox"]')) return;
      var v = e.target.closest('.w-radio, .w-checkbox');
      v = v && v.querySelector('.w-form-formradioinput, .w-checkbox-input');
      if (v) v.classList.remove('w--redirected-focus');
    });
    syncFormControls();
  }

  /* ------------------------------------------------------------ Shopify forms
     Shopify's {% form %} tag renders method="get" on this store, which would
     submit the fields as a query string and never reach the inbox. The hidden
     form_type input marks a real Shopify form, so correct the method in place. */
  function fixShopifyForms() {
    document.querySelectorAll('form input[name="form_type"]').forEach(function (marker) {
      var form = marker.form || marker.closest('form');
      if (form && form.getAttribute('method') !== 'post') form.setAttribute('method', 'post');
    });
  }

  // Language selector: a <details>, so opening and switching work without this.
  // All this adds is the dismissal a native dropdown would give for free.
  function initLanguageSelector() {
    var boxes = document.querySelectorAll('[data-nav-lang]');
    if (!boxes.length) return;
    document.addEventListener('click', function (e) {
      Array.prototype.forEach.call(boxes, function (el) {
        if (el.open && !el.contains(e.target)) el.open = false;
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      Array.prototype.forEach.call(boxes, function (el) {
        if (!el.open) return;
        el.open = false;
        var summary = el.querySelector('summary');
        if (summary) summary.focus();
      });
    });
  }

  // The PDP gallery can open with a reveal video. It carries `autoplay muted
  // loop`, so it plays on its own with no JavaScript at all; this only stops it
  // when it is not the slide you are looking at, and honours reduced motion.
  function initGalleryVideo() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('.product_main_video'));
    if (!videos.length) return;

    var onScreen = true;
    var apply = function () {
      videos.forEach(function (v) {
        var slide = v.closest('.swiper-slide');
        var active = !slide || slide.classList.contains('is-active') ||
                     slide.classList.contains('swiper-slide-active');
        if (active && onScreen && !reduced) {
          if (v.paused) {
            var p = v.play();
            if (p && p.catch) p.catch(function () { /* the browser declined */ });
          }
        } else if (!v.paused) {
          v.pause();
        }
      });
    };
    if (reduced) videos.forEach(function (v) { v.pause(); v.removeAttribute('autoplay'); });

    // Swiper moves the active class without firing a DOM event we can listen
    // for from here, so watch the class instead of guessing at its API
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(apply);
      videos.forEach(function (v) {
        var list = v.closest('.swiper-wrapper') || v.parentElement;
        if (list) mo.observe(list, {subtree: true, attributes: true, attributeFilter: ['class']});
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { onScreen = e.isIntersecting; });
        apply();
      }, {threshold: 0.1});
      videos.forEach(function (v) { io.observe(v); });
    }
    apply();
  }

  function init() {
    // each step is independent: one failing must not skip the others
    [initParallax, initCardTilt, initFooterBlur, initLazyVideo, initForms, initFormControls,
     fixShopifyForms, initLanguageSelector, initGalleryVideo]
      .forEach(function (fn) {
        try { fn(); } catch (e) { console.warn('site.js ' + fn.name + ':', e && e.message); }
      });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // apps can rewrite form attributes after load, so check once more at the end
  window.addEventListener('load', function () {
    try { fixShopifyForms(); } catch (e) { /* nothing to do */ }
  });
})();
